module.exports = __webpack_public_path__ + "media/images/avatar-527304008253645640cbd6c66870e5b3.png";